import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-new-rankings-search-filter',
  templateUrl: './rankings-search-filter.component.html',
  styleUrls: [
    './rankings-search-filter.component.scss',
    '../rankings-responsive.scss'
  ]
})
export class RankingsSearchFilterComponent implements OnInit {
  @Output()
  searchEvent: EventEmitter<any> = new EventEmitter<any>();

  searchQuery = '';

  constructor() {}

  ngOnInit(): void {}

  onQueryChange(): void {
    const q = this.searchQuery.trim().toLowerCase();
    this.searchEvent.emit(q);
  }

  clearSearch(): void {
    this.searchQuery = '';
    this.searchEvent.emit();
  }
}
